import script from "./AlertasView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertasView.vue?vue&type=script&setup=true&lang=js"

import "./AlertasView.vue?vue&type=style&index=0&id=d9c7cfe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c7cfe4"]])

export default __exports__